import { Badge } from "@chakra-ui/react";

// Fonte única de verdade para label/cor de cada status de plantão exibido — reaproveitado
// por features/plantoes/utils/statusPlantao.js sempre que a UI de outra feature precisar
// do mesmo mapeamento (ex.: chips de filtro em Recebíveis).
export const STATUS_META = {
  recebido: { label: "Recebido", colorScheme: "success" },
  aguardando_nf: { label: "Aguardando NF", colorScheme: "warning" },
  previsto: { label: "A receber", colorScheme: "teal" },
  em_atraso: { label: "Em atraso", colorScheme: "danger" },
};

export default function StatusBadge({ status, ...rest }) {
  const meta = STATUS_META[status] ?? { label: status, colorScheme: "gray" };
  return (
    <Badge variant="statusSubtle" colorScheme={meta.colorScheme} {...rest}>
      {meta.label}
    </Badge>
  );
}
